import React from 'react';
import { Link } from 'react-router-dom';
import CustomerDowntimeTable from './CustomerDowntimeTable';
import { useUser } from '../../../../../hooks/shared/user/useUser';
// import BusinessDevelopmentSideBar from '../../../../layouts/business-development/BusinessDevelopmentSideBar';
import BusinessDevelopmentNavBar from '../../../../layouts/business-development/BusinessDevelopmentNavBar';

export default function CustomerDowntimeOverview() {
  const { profile, user } = useUser();
  const { firstName } = profile;

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <BusinessDevelopmentNavBar
          currentPage="Dedicated Customer Network Status"
          roleID={user.role_id}
          position={firstName}
        />
        {/* <div style={{ width: '100%' }}> */}
        <CustomerDowntimeTable />
        {/* </div> */}
      </main>
    </div>
  );
}
